import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Drawer, makeStyles } from '@material-ui/core';
import {
  List,
  EditButton,
  DeleteButton,
  Datagrid,
  CardActions,
  CreateButton,
  FunctionField,
  TextField,
} from 'react-admin';
import { Route } from 'react-router';
import QuoteCreate from './QuoteCreate';
import QuoteEdit from './QuoteEdit';

const useStyles = makeStyles({
  drawerContent: {
    width: 300,
  },
});

const QuoteListActions = ({ basePath }) => (
   <CardActions>
       <CreateButton basePath={basePath} />
   </CardActions>
);

const QuoteList = props => {
  const classes = useStyles();

  const handleClose = () => {
    props.push("/quotes");
  };

  return (
    <React.Fragment>
      <List {...props} sort={{ field: 'createdAt', order: 'DESC' }} actions={<QuoteListActions />}>
        <Datagrid>
          <TextField source="author" />
          <TextField source="text" />
          <EditButton />
          <DeleteButton />
        </Datagrid>
      </List>

      <Route path="/quote/create">
        {({ match }) => {
          //console.log('CREATE?')
          return;
          return (
            <Drawer open={!!match} anchor="right" onClose={handleClose}>
              <QuoteCreate onCancel={handleClose} className={classes.drawerContent} {...props} />
            </Drawer>
          )
        }}
      </Route>
      <Route path="/quote/:id">
        {({ match }) => {
          const isMatch = match && match.params && match.params.id !== "create";

          return (
            <Drawer open={isMatch} anchor="right" onClose={handleClose} >
              {isMatch ? (
                <QuoteEdit
                  id={match.params.id}
                  onCancel={handleClose}
                  className={classes.drawerContent}
                  {...props}
                />
              ) : (
                  <div className={classes.drawerContent} />
              )}
            </Drawer>
          );
        }}
      </Route>
    </React.Fragment>
  );
}

export default connect(
  undefined,
  { push }
)(QuoteList);


